var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-page',{staticClass:"client sign",attrs:{"profile":_vm.profile}},[_c('v-topbar',{attrs:{"profile":_vm.profile}}),_vm._v(" "),(_vm.profile === 'client')?_c('v-breadcrumb',{attrs:{"steps":[
      { label: 'Profissionais', to: { name: 'client-vibbrants' } },
      {
        label: _vm.contract.vibbrante.name,
        to: { name: 'client-vibbrants-pending' },
      },
      { label: 'Contrato' } ]}}):_c('v-breadcrumb',{attrs:{"steps":[
      { label: 'Clientes', to: { name: 'vibbrant-clients' } },
      {
        label: _vm.contract.client.name,
        to: { name: 'vibbrant-clients-pending' },
      },
      { label: 'Contrato' } ]}}),_vm._v(" "),(_vm.contract.contract_type === 'vibbrante')?_c('v-vibbrante-contract',{attrs:{"profile":_vm.profile}}):_vm._e(),_vm._v(" "),(_vm.contract.contract_type === 'freelancer')?_c('v-freelancer-contract',{attrs:{"profile":_vm.profile}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39a96028","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/parts/pages/sign.vue
// module id = null
// module chunks = 